export default "__VITE_ASSET__DBHI_Oig__"